import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext({ settings: null, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  async function refresh() {
    try {
      const r = await api.get("/settings");
      setSettings(r.data);
    } catch { /* ignore */ }
  }

  useEffect(() => { refresh(); }, []);

  // Inject GA4 / GTM / FB Pixel once settings are loaded
  useEffect(() => {
    if (!settings) return;
    const { ga4_id, gtm_id, fb_pixel_id } = settings;

    if (ga4_id && !document.getElementById("ga4-src")) {
      const s = document.createElement("script");
      s.id = "ga4-src";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4_id}`;
      document.head.appendChild(s);
      const inline = document.createElement("script");
      inline.id = "ga4-init";
      inline.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config','${ga4_id}');`;
      document.head.appendChild(inline);
    }
    if (gtm_id && !document.getElementById("gtm-init")) {
      const inline = document.createElement("script");
      inline.id = "gtm-init";
      inline.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtm_id}');`;
      document.head.appendChild(inline);
    }
    if (fb_pixel_id && !document.getElementById("fbp-init")) {
      const inline = document.createElement("script");
      inline.id = "fbp-init";
      inline.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${fb_pixel_id}');fbq('track','PageView');`;
      document.head.appendChild(inline);
    }
  }, [settings]);

  return <SettingsContext.Provider value={{ settings, refresh }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
